module.exports = __webpack_public_path__ + "img/flammer.b937aaad.jpg";